// extracted by mini-css-extract-plugin
export default {"mainCom":"mainCom_mainCom__pRDWb"};